import { useMemo } from "react"
import { useSelectedAccount } from "../contexts/AccountContext"

// 選択中アカウントの最古の連携日を YYYY-MM-DD 形式で返す
// アカウント未選択・日付不正の場合は undefined
export const useEarliestAccountDate = (): string | undefined => {
  const { selectedAccountIds, organizations } = useSelectedAccount()

  return useMemo(() => {
    const selected = organizations
      .flatMap(o => o.accounts)
      .filter(a => selectedAccountIds.includes(a.id))

    if (selected.length === 0) return undefined

    // created_at は "YYYY/MM/DD" 形式で返ってくるため "-" に正規化
    const dates = selected
      .map(a => a.created_at?.replace(/\//g, "-"))
      .filter((d): d is string => Boolean(d) && /^\d{4}-\d{2}-\d{2}$/.test(d))
      .sort()

    return dates[0]
  }, [selectedAccountIds, organizations])
}
